<form #detachTruckAndTrailerForm="ngForm">
  <sc-title>{{'step title' | translate: ['tmc.transport-attach-detach.dialog.step.title.detach-truck-and-trailer', translationService.language]}}</sc-title>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <sc-string-field name="swapTrailerNumber" [label]="'swap trailer number' | translate: ['tmc.transport-attach-detach.dialog.label.swapTrailerNumber', translationService.language]" [required]="true" [(ngModel)]="stepperModel.workingData.swapTrailerNumber" [grow]="true"></sc-string-field>
</form>
